import { Card, Collapse, message, Select, Spin, Switch, Tooltip } from "antd";
import React, { useEffect, useState, useMemo } from "react";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { ButtonFilled } from "../../Reusablecomponents/UIButtons";

const { Panel } = Collapse;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 370px !important;
    height: 36px !important;
    border-radius: 20px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: #e7e7ed;
  }
  .ant-select-selection-item {
    line-height: 36px;
  }
  @media (max-width: 480px) {
    .ant-select-selector {
      width: 270px !important;
    }
  }
`;

const RoleAction = () => {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const roleList = useSelector((state) => state?.authTracking?.roleList);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [allRoleSelect, setAllRoleSelect] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const addActionAllowed = useMemo(
    () => hasPermission("ROLE", "AATR"),
    [reduxPermissions],
  );
  const fetchAllRoleAction = async () => {
    try {
      setLoading(true);
      const response = await CALL_API("POST", "role/roleAction", {
        MCID: userInfo?.MCID,
        ROLEId: selectedRole,
      });
      setPermissions(response.data);
    } catch (error) {
      console.error("[fetchAllRoleAction] error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRole = (checked) => {
    setAllRoleSelect(checked);
    if (checked) {
      const allPermissions = permissions.flatMap((group) =>
        group.Sections.flatMap((section) =>
          Object.values(section.actions)?.map((action) => ({
            secCode: section.secCode,
            action: action.code,
          })),
        ),
      );
      setSelectedRoles(allPermissions);
    } else {
      setSelectedRoles([]);
    }
  };

  const handleActionToggle = (secCode, action, checked) => {
    setSelectedRoles((prev) => {
      const updatedRoles = checked
        ? [...prev, { secCode, action }]
        : prev.filter(
            (item) => !(item.secCode === secCode && item.action === action),
          );

      const allPermissions = permissions.flatMap((group) =>
        group.Sections.flatMap((section) =>
          Object.values(section.actions)?.map((action) => ({
            secCode: section.secCode,
            action: action.code,
          })),
        ),
      );

      setAllRoleSelect(updatedRoles.length === allPermissions.length);
      return updatedRoles;
    });
  };
  const handleSave = () => {
    if (!selectedRole) {
      message.error("Please select the Role before saving.");
      return;
    }
    handleAction(selectedRole);
  };
  const fetchMyPermissions = async () => {
    try {
      const { data } = await CALL_API("GET", `role/getMyPermissions`);

      // Normalize response (flatten nested arrays if present)
      let items = data ?? [];
      if (
        Array.isArray(items) &&
        items.length === 1 &&
        Array.isArray(items[0])
      ) {
        items = items[0];
      }
      if (Array.isArray(items) && items.some(Array.isArray))
        items = items.flat(1);

      const perms = (items || []).reduce((acc, item) => {
        const code = (item?.SECCODE || "").toUpperCase();
        const action = (item?.ACTION || "").toUpperCase();
        if (!code) return acc;
        if (!acc[code]) acc[code] = new Set();
        acc[code].add(action);
        return acc;
      }, {});

      const permObj = Object.keys(perms).reduce((acc, k) => {
        acc[k] = Array.from(perms[k]);
        return acc;
      }, {});
    } catch (err) {
      console.error("Error loading permissions:", err);
    }
  };
  const handleAction = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "POST",
        `role/addActionToRole?roleId=${selectedRole}`,
        selectedRoles,
      );
      message.success("Role Action Added Successfully");
      fetchSubscriptionData();
      fetchMyPermissions();
    } catch (error) {
      console.error("[handleAction] error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubscriptionData = async () => {
    if (!selectedRole) return;
    setLoading(true);
    try {
      setLoading(true);
      const response = await CALL_API(
        "GET",
        `role/getActionsByRoleId?mcId=${userInfo?.MCID}&RoleId=${selectedRole}`,
      );
      setSubscriptionDetails(response.data);
      setLoading(false);
    } catch (error) {
      console.error("[fetchSubscriptionData] error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSelectedRoles(
      subscriptionDetails?.map((item) => ({
        secCode: item.SECCODE,
        action: item.ACTION,
      })),
    );
  }, [subscriptionDetails]);

  useEffect(() => {
    if (!selectedRole) return;
    fetchAllRoleAction();
    fetchSubscriptionData();
  }, [selectedRole]);

  // useEffect(() => {
  //   fetchAllRoleAction();
  // }, []);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center selectrole_container_three mx-4">
        <div>
          <span>
            Select Role
            <StyledSelect
              value={selectedRole}
              options={roleList?.map((item) => ({
                value: item.ROLEID,
                label: item.ROLENAME,
              }))}
              placeholder="Select Role"
              onChange={(values) => {
                setSelectedRole(values);
              }}
            />
          </span>
          <Tooltip title={!addActionAllowed ? "No permission" : ""}>
            <ButtonFilled loading={loading} onClick={handleSave}>
              Save
            </ButtonFilled>
          </Tooltip>
        </div>
        {selectedRole && (
          <div className="rollActionName_containerfor_switch">
            <span className="Choose_all">Choose All </span>
            <Tooltip title={!addActionAllowed ? "No permission" : ""}>
              <Switch
                disabled={!addActionAllowed}
                checked={allRoleSelect}
                onChange={handleRole}
              />
            </Tooltip>
          </div>
        )}
      </div>
      {selectedRole && (
        <Spin spinning={loading}>
          <Card style={{ backgroundColor: "transparent", border: "none" }}>
            <Collapse>
              {permissions?.map((group, groupIndex) => (
                <Panel key={groupIndex} header={group?.Group}>
                  <Collapse>
                    {group?.Sections?.map((section, sectionIndex) => (
                      <Panel key={sectionIndex} header={section.section}>
                        {Object.keys(section?.actions)?.map(
                          (key, actionIndex) => (
                            <div
                              className="d-flex justify-content-between p-2"
                              style={{
                                color: "#000",
                                borderRadius: "8px",
                                padding: "10px",
                                marginBottom: "8px",
                              }}
                              key={actionIndex}
                            >
                              <strong>{section.actions[key].desc}</strong>
                              <Tooltip
                                title={!addActionAllowed ? "No permission" : ""}
                              >
                                <Switch
                                  disabled={!addActionAllowed}
                                  checked={selectedRoles?.some(
                                    (item) =>
                                      item?.secCode === section?.secCode &&
                                      item?.action ===
                                        section?.actions[key].code,
                                  )}
                                  onChange={(checked) =>
                                    handleActionToggle(
                                      section?.secCode,
                                      section?.actions[key].code,
                                      checked,
                                    )
                                  }
                                />
                              </Tooltip>
                            </div>
                          ),
                        )}
                      </Panel>
                    ))}
                  </Collapse>
                </Panel>
              ))}
            </Collapse>
          </Card>
        </Spin>
      )}
    </div>
  );
};

export default RoleAction;
